import { LocaleKeys } from '../../../../locale/translation-types'

export enum DeactivationReasonEnum {
  NOT_AVAILABLE_ANYMORE = 'NOT_AVAILABLE_ANYMORE',
  MOVED_AWAY = 'MOVED_AWAY',
  NOT_SUITABLE = 'NOT_SUITABLE'
}

export const deactivationReasonEnumMapping: Record<DeactivationReasonEnum, string> = {
  [DeactivationReasonEnum.NOT_AVAILABLE_ANYMORE]: 'Plus disponible',
  [DeactivationReasonEnum.MOVED_AWAY]: 'A déménagé',
  [DeactivationReasonEnum.NOT_SUITABLE]: 'Pas adapté'
}

export const hostFamilyDeactivationReasonEnumMapping: Record<DeactivationReasonEnum, LocaleKeys> =
  {
    [DeactivationReasonEnum.NOT_AVAILABLE_ANYMORE]:
      'host.family.deactivation.reason.enum.NOT_AVAILABLE_ANYMORE',
    [DeactivationReasonEnum.MOVED_AWAY]: 'host.family.deactivation.reason.enum.MOVED_AWAY',
    [DeactivationReasonEnum.NOT_SUITABLE]: 'host.family.deactivation.reason.enum.NOT_SUITABLE'
  }

// reasons an OL may pick for its own host families, NOT_SUITABLE is reserved to LEC (enforced by the backend)
export const OL_HOST_FAMILY_DEACTIVATION_REASONS: DeactivationReasonEnum[] = [
  DeactivationReasonEnum.NOT_AVAILABLE_ANYMORE,
  DeactivationReasonEnum.MOVED_AWAY
]
